<div mat-dialog-title class="ds">
  <span>{{ appStrings.leads_validateLeadDeliveryTitle }}</span>
  <button mat-icon-button class="close-dialog-button" mat-dialog-close>
    <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>

@if (loading) {
  <div id="loadingContainer" class="overlay full">
    <p class="text-center">{{ appStrings.pleaseWait }}</p>
    <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
  </div>
}

<div mat-dialog-content class="content ds">
  <div class="dialog-body">
    <div class="row">
      <typography id="name_label" class="label" variant="mat-caption-2" weight="regular"> {{ appStrings.accounts_labelName }} </typography>
      <typography id="name" class="details" variant="mat-body-1" weight="medium"> {{ element.name1 }} </typography>
    </div>
    <div class="row">
      <typography id="address_label" class="label" variant="mat-caption-2" weight="regular"> {{ appStrings.accounts_labelAddress }} </typography>
      <typography id="address" class="details" variant="mat-body-1" weight="medium"> {{ element.address }} </typography>
    </div>
  </div>
</div>

<div mat-dialog-actions align="end" class="ds dialog-actions">
  <div class="dialog-btn-wrapper">
    <ds-button id="close-button" variant="label-only" size="medium"
      type="tertiary" (onClick)="close()" [label]="appStrings.button_close">
    </ds-button>
    <ds-button id="leadDeliveryEditButton" variant="label-only" size="medium"
      type="secondary" (onClick)="edit()" [label]="appStrings.button_edit">
    </ds-button>
    <ds-button id="send-delivery-email-button" variant="label-only" size="medium"
      type="primary" (onClick)="sendDeliveryEmailDetails()" [label]="appStrings.accounts_validate">
    </ds-button>
  </div>
</div>